import { Box, Typography } from "@mui/material";
import NoFiltersIcon from "src/assets/svg-icons/no-filters.svg";

const NoFilterSelected = ({
  message = "Please select the required data to see results.",
}: {
  message?: string;
}) => {
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      gap={"2px"}
      justifyContent={"center"}
      alignItems={"center"}
      height={"60vh"}
    >
      <img src={NoFiltersIcon} alt="" />
      <Typography fontSize={"20px"} align="center" sx={{ color: "#938A80" }}>
        {message}
      </Typography>
    </Box>
  );
};

export default NoFilterSelected;
